var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "menus_bottom_config",
      attrs: { disabled: _vm.disabled, model: _vm.value.config },
    },
    [
      _c("div", { staticClass: "label" }, [
        _vm._v(" 设置分类及排序 "),
        _c("span", { staticClass: "tips" }, [_vm._v("（拖动分类可调整排序）")]),
      ]),
      _c(
        "draggable",
        {
          attrs: { animation: "500", "force-fallback": true },
          model: {
            value: _vm.value.config.value,
            callback: function ($$v) {
              _vm.$set(_vm.value.config, "value", $$v)
            },
            expression: "value.config.value",
          },
        },
        _vm._l(_vm.value.config.value, function (item, index) {
          return _c(
            "div",
            { key: index, class: ["box", !item.flag && "disabled"] },
            [
              _c(
                "div",
                { staticClass: "list name" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "value." + index + ".flag",
                        rules: [
                          {
                            required: true,
                            validator: function (rule, value, callback) {
                              return _vm.checkFlag(rule, value, callback)
                            },
                          },
                        ],
                      },
                    },
                    [
                      _c("div", { staticClass: "label" }, [
                        _vm._v(" " + _vm._s(item.name) + " "),
                      ]),
                      _c(
                        "div",
                        { staticClass: "value" },
                        [
                          item.type === "normal"
                            ? _c("i", {
                                staticClass: "el-icon el-icon-delete",
                                on: {
                                  click: function ($event) {
                                    return _vm.delClassify(index)
                                  },
                                },
                              })
                            : _vm._e(),
                          _c("el-switch", {
                            attrs: {
                              "active-value": true,
                              "inactive-value": false,
                            },
                            model: {
                              value: item.flag,
                              callback: function ($$v) {
                                _vm.$set(item, "flag", $$v)
                              },
                              expression: "item.flag",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "list disableMode" },
                [
                  _c("div", { staticClass: "label nickName" }, [
                    _vm._v(" 展示为 "),
                  ]),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { flex: "1" },
                      attrs: {
                        prop: "value." + index + ".name_alias",
                        rules: item.flag
                          ? [
                              {
                                required: true,
                                message: "展示名称不可为空",
                                trigger: "change",
                              },
                              {
                                max: 10,
                                message: "名称长度最多10个字",
                                trigger: "change",
                              },
                            ]
                          : [],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { clearable: "", disabled: !item.flag },
                        model: {
                          value: item.name_alias,
                          callback: function ($$v) {
                            _vm.$set(item, "name_alias", $$v)
                          },
                          expression: "item.name_alias",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "uploadBox disableMode" },
                [
                  _c("div", { staticClass: "label" }, [
                    _vm._v("图标（未选中）"),
                  ]),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "value." + index + ".imageurl",
                        rules: item.flag
                          ? [
                              {
                                required: true,
                                message: "图标（未选中）不可为空",
                              },
                            ]
                          : [],
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "upload-item-wrap" },
                        [
                          _c("upload-file", {
                            ref: "uploadBanner",
                            refInFor: true,
                            attrs: {
                              "link-url": _vm.linkUrl,
                              tempurl: item.imageurl,
                              disabled: !item.flag,
                              canDel: Boolean(item.imageurl),
                              uploadInfo: _vm.uploadInfo,
                            },
                            on: {
                              onDelete: function ($event) {
                                return _vm.delImg(item, "imageurl")
                              },
                              emitUploadFile: function (res) {
                                return _vm.emitUploadFile(res, item, "imageurl")
                              },
                            },
                          }),
                          _c(
                            "div",
                            { staticClass: "right" },
                            [
                              _c(
                                "el-button",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.onUpload(index * 2 + 0)
                                    },
                                  },
                                },
                                [_vm._v("上传图片")]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.selectPicture(
                                        index,
                                        "imageurl"
                                      )
                                    },
                                  },
                                },
                                [_vm._v("选择图片")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "uploadBox disableMode" },
                [
                  _c("div", { staticClass: "label" }, [_vm._v("图标（选中）")]),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "value." + index + ".active_imageurl",
                        rules: item.flag
                          ? [
                              {
                                required: true,
                                message: "图标（选中）不可为空",
                              },
                            ]
                          : [],
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "upload-item-wrap" },
                        [
                          _c("upload-file", {
                            ref: "uploadBanner",
                            refInFor: true,
                            attrs: {
                              "link-url": _vm.linkUrl,
                              tempurl: item.active_imageurl,
                              disabled: !item.flag,
                              canDel: Boolean(item.imageurl),
                              uploadInfo: _vm.uploadInfo,
                            },
                            on: {
                              onDelete: function ($event) {
                                return _vm.delImg(item, "active_imageurl")
                              },
                              emitUploadFile: function (res) {
                                return _vm.emitUploadFile(
                                  res,
                                  item,
                                  "active_imageurl"
                                )
                              },
                            },
                          }),
                          _c(
                            "div",
                            { staticClass: "right" },
                            [
                              _c(
                                "el-button",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.onUpload(index * 2 + 1)
                                    },
                                  },
                                },
                                [_vm._v("上传图片")]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.selectPicture(
                                        index,
                                        "active_imageurl"
                                      )
                                    },
                                  },
                                },
                                [_vm._v("选择图片")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              item.type === "normal"
                ? _c(
                    "div",
                    { staticClass: "disableMode" },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "radio",
                          attrs: {
                            prop: "value." + index + ".link_type",
                            rules: item.flag
                              ? [
                                  {
                                    required: true,
                                    message: "菜单类型不可为空",
                                    trigger: "change",
                                  },
                                ]
                              : [],
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { disabled: !item.flag },
                              on: {
                                change: function ($event) {
                                  return _vm.changeType(item)
                                },
                              },
                              model: {
                                value: item.link_type,
                                callback: function ($$v) {
                                  _vm.$set(item, "link_type", $$v)
                                },
                                expression: "item.link_type",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("选菜单"),
                              ]),
                              _c("el-radio", { attrs: { label: 2 } }, [
                                _vm._v("输入链接"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "value." + index + ".link_value",
                            rules: item.flag
                              ? [
                                  {
                                    required: true,
                                    message: "菜单链接不可为空",
                                    trigger: "change",
                                  },
                                ]
                              : [],
                          },
                        },
                        [
                          item.link_type === 1
                            ? _c("el-cascader", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  options: _vm.menuList,
                                  "collapse-tags": "",
                                  props: {
                                    label: "show_name",
                                    value: "id",
                                    children: "childrens",
                                    checkStrictly: true,
                                    emitPath: false,
                                  },
                                  disabled: !item.flag,
                                  clearable: "",
                                  placeholder: "选择菜单",
                                },
                                model: {
                                  value: item.link_value,
                                  callback: function ($$v) {
                                    _vm.$set(item, "link_value", $$v)
                                  },
                                  expression: "item.link_value",
                                },
                              })
                            : _vm._e(),
                          item.link_type === 2
                            ? _c("el-input", {
                                attrs: {
                                  placeholder: "请输入菜单链接",
                                  clearable: "",
                                },
                                model: {
                                  value: item.link_value,
                                  callback: function ($$v) {
                                    _vm.$set(item, "link_value", $$v)
                                  },
                                  expression: "item.link_value",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          )
        }),
        0
      ),
      _c("div", { staticClass: "label" }, [
        _c("span", { staticClass: "tips" }, [
          _vm._v("支持PNG、JPG等格式，2M以内，建议尺寸为44*44"),
        ]),
      ]),
      _vm.showPictureLibrary
        ? _c("picture-library", {
            attrs: {
              configData: _vm.value,
              pictureList: _vm.pictureList,
              depot: _vm.depot,
            },
            on: {
              onClose: function ($event) {
                _vm.showPictureLibrary = false
              },
              onSubmit: _vm.onChangePic,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }